export default __webpack_public_path__ + "static/media/Etape6_Buisson_surface_After_Filtre.fa4d4766.jpg";